import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import mailIcon from "../../../../assets/mail.svg";
import * as styles from "./Footer.module.scss";

export const Footer = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.main}>
        <div className={styles.links}>
          <div className={styles.left}>
            <Link to="/">
              <StaticImage
                src="../../../../assets/logo_white.svg"
                alt="logo"
                placeholder="tracedSVG"
                imgStyle={{ objectFit: "contain" }}
                width={211}
              />
            </Link>
          </div>
          <div className={styles.middle}>
            <h6>Har du stadig spørgsmål?</h6>
            <p>Tryk 'Kontakt' for at sende en mail til os. Så ser vi på spørgsmålet.</p>
          </div>
          <div className={styles.right}>
            <a href="mailto:info@multiregnskab.dk">
              <button type="button">
                <img src={mailIcon} alt="contact" />
                Kontakt
              </button>
            </a>
          </div>
        </div>
      </div>
      <div className={styles.bottom}>
        <div className={styles.container}>
          <div className={styles.left}>
            <span>
              Klausdalsbrovej 601 <br />
              2750 Ballerup <br />
              Denmark
            </span>
            <span className={styles.cvr}>CVR 39 23 93 53</span>
          </div>
          <div className={styles.middle}>
            <a href="mailto:info@multiregnskab.dk">info@multiregnskab.dk</a>
          </div>
          <div className={styles.right}>
            <a href="mailto:info@multiregnskab.dk">info@multiregnskab.dk</a>
            <p>
              Al tekst, alle billeder og videoer på denne side, er beskyttet af loven om ophavsret. Det er ikke tilladt
              at "låne" eller kopiere hele eller dele af teksten uden forudgående skriftlig tilladelse.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
